import { render, staticRenderFns } from "./NotificationsLayout.vue?vue&type=template&id=2668e1aa&scoped=true"
import script from "./NotificationsLayout.vue?vue&type=script&lang=js"
export * from "./NotificationsLayout.vue?vue&type=script&lang=js"
import style0 from "./NotificationsLayout.vue?vue&type=style&index=0&id=2668e1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2668e1aa",
  null
  
)

export default component.exports